export class User{
  constructor(
    public ID:number,
    private username:string,
    private password:string,
    private Role_ID:number
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/user.model.ts